import React, { useEffect, useState } from 'react';
import './HealthLoadingAnimation.css';

interface HealthLoadingAnimationProps {
  visible: boolean;
}

const healthQuotes = [
  '养生不是硬扛，是把每天的消耗慢慢降下来。',
  '先稳睡眠，再谈状态。先护脾胃，再谈气色。',
  '焦虑会耗气，久坐会伤阳，节律乱了身体先报警。',
  '顺时而养，不求猛补，先把身体从透支里拉回来。',
  '知道短板不是焦虑，是开始认真保护自己。',
  '鲍姑是晋代岭南女医，擅长灸法与外治，长期为百姓治病。',
];

const HealthLoadingAnimation: React.FC<HealthLoadingAnimationProps> = ({ visible }) => {
  const [progress, setProgress] = useState(0);
  const [quoteIndex, setQuoteIndex] = useState(0);

  useEffect(() => {
    if (!visible) {
      setProgress(0);
      setQuoteIndex(0);
      return;
    }

    const progressTimer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 99) return 99;
        if (prev >= 92) return prev + 0.05;
        if (prev >= 80) return prev + 0.12;
        if (prev >= 60) return prev + 0.22;
        if (prev >= 35) return prev + 0.35;
        return prev + 0.52;
      });
    }, 500);

    const quoteTimer = setInterval(() => {
      setQuoteIndex((prev) => (prev + 1) % healthQuotes.length);
    }, 3200);

    return () => {
      clearInterval(progressTimer);
      clearInterval(quoteTimer);
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="health-loading-overlay">
      <div className="health-loading-container">
        <div className="health-loading-taiji-wrap">
          <div className="health-loading-taiji">
            <div className="health-loading-yin" />
            <div className="health-loading-yang" />
            <div className="health-loading-dot-yin" />
            <div className="health-loading-dot-yang" />
          </div>
          <div className="health-loading-ring health-loading-ring-1" />
          <div className="health-loading-ring health-loading-ring-2" />
          <div className="health-loading-ring health-loading-ring-3" />
          <div className="health-loading-glow" />
          <div className="health-loading-halo" />
        </div>

        <div className="health-loading-title">正在生成身心健康报告...</div>
        <div className="health-loading-subtitle">正在进行体质与节律评估</div>

        <div className="health-loading-progress-wrap">
          <div className="health-loading-progress-bg">
            <div className="health-loading-progress-fill" style={{ width: `${progress}%` }} />
          </div>
          <div className="health-loading-progress-text">{Math.floor(progress)}%</div>
        </div>

        <div className="health-loading-quote">{healthQuotes[quoteIndex]}</div>

        <div className="health-loading-stages">
          {[
            { icon: '🫁', label: '识别体质', active: progress >= 0 },
            { icon: '🧭', label: '校准气候', active: progress >= 30 },
            { icon: '🌿', label: '生成建议', active: progress >= 65 },
            { icon: '📜', label: '完成报告', active: progress >= 90 },
          ].map((stage, idx) => (
            <div key={idx} className={`health-loading-stage ${stage.active ? 'active' : ''}`}>
              <div className="health-loading-stage-icon">{stage.icon}</div>
              <div className="health-loading-stage-label">{stage.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HealthLoadingAnimation;
